module.exports = __webpack_public_path__ + "static/media/humidity.92fa7242.svg";